
import { oz } from '@weft/utils';
import { BILLING_INTERVALS } from './billing-interval-schema';

export const USER_INPUT_BILLING_INTERVALS = Object.freeze({
  ...BILLING_INTERVALS,
  Inherit: 'Inherit',
});

export const UserInputBillingIntervalSchema = oz.nativeEnum(USER_INPUT_BILLING_INTERVALS).openapi('UserInputBillingInterval');

export type UserInputBillingInterval = oz.infer<typeof UserInputBillingIntervalSchema>;